import React, { createContext } from 'react';
interface UserContextType {
  userRole: 'employee' | 'manager';
  userName: string;
  toggleRole: () => void;
}
export const UserContext = createContext<UserContextType>({
  userRole: 'employee',
  userName: 'Marie Dupont',
  toggleRole: () => {}
});